import React from 'react';

export const ContributeInfo: React.FC = () => {
  return (
    <div className="bg-gray-50 p-8 rounded-lg shadow-md max-w-4xl mx-auto mt-12">
      <h2 className="text-2xl font-bold text-blue-600 mb-4 text-center">Contribute to Peptide Now</h2>
      <p className="text-gray-700 mb-6 text-center">
        We welcome your data, research, and ideas to help improve Peptide Now. Here's how you can contribute:
      </p>

      <div className="space-y-6">
        <div className="p-4 bg-white rounded-lg shadow">
          <h3 className="text-lg font-semibold text-blue-600">1. Share Your Ideas</h3>
          <p className="text-gray-700">
            Have ideas or suggestions? Email us at{' '}
            <a
              href="mailto:peptidenow@gmail.com"
              className="text-blue-500 hover:underline"
            >
              peptidenow@gmail.com
            </a>.
          </p>
        </div>

        <div className="p-4 bg-white rounded-lg shadow">
          <h3 className="text-lg font-semibold text-blue-600">2. Share Research Data</h3>
          <p className="text-gray-700">
            Contribute research data using our sample spreadsheet as a guide.{' '}
            <a
              href="https://docs.google.com/spreadsheets/d/15CoCXNrywWBlCOnZtEMjkNrVLWzhkcP16FWCU_zC418/edit?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              View Sample Spreadsheet
            </a>.
          </p>
        </div>

        <div className="p-4 bg-white rounded-lg shadow">
          <h3 className="text-lg font-semibold text-blue-600">3. Collaborate on GitHub</h3>
          <p className="text-gray-700">
            Submit CSV files or report issues directly on our GitHub repository.{' '}
            <a
              href="https://github.com/peptidenow/sample-data/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              Visit GitHub Repository
            </a>.
          </p>
        </div>
      </div>

      <p className="text-center text-sm text-gray-500 mt-8">
        Thank you for contributing to Peptide Now. Together, we can advance research and data accuracy.
      </p>
    </div>
  );
};
